import { Search } from 'lucide-react';
import React, { ChangeEvent } from 'react';
import { theme } from 'styles/theme/theme';
import UDInput from 'ud-form/components/input/component';
import Label from 'ud-ui/components/label';

import { DivProps } from '../../../../../typings';
import { MainBlock } from './styles';

type IProps = Omit<DivProps, 'onChange'> & {
  headerText: string;
  value?: string;
  onChange?: (value: string) => void;
  parser?: (value: string) => string;
  placeholder?: string;
};

function SearchInput(props: IProps) {
  const { headerText, value, onChange, placeholder, parser, ...rest } = props;

  const onChangeComponent = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    onChange?.(value);
  };

  return (
    <MainBlock {...rest}>
      <Label text={headerText}>
        <UDInput
          onChange={onChangeComponent}
          value={value}
          iconProps={{ position: 'icon-left', component: <Search size={16} color={theme.colors.SurfaceRomanSilver30} /> }}
          placeholder={placeholder}
          style={{ height: 36, width: '100%' }}
          parser={parser}
        />
      </Label>
    </MainBlock>
  );
}

export default SearchInput;
